<template>
  <v-app>
    <NavBar :drawer="drawer" v-on:drawer="drawer = $event" @logout="logout" />
    <v-app-bar
      app
      :color="color"
      dark
    >
      <v-app-bar-nav-icon v-if="$store.getters.isAuthenticated" @click.stop="drawer = !drawer" />
      <v-app-bar-title class="text-uppercase grow">Daikin</v-app-bar-title>

      <v-spacer></v-spacer>

      <div v-if="$store.getters.isAuthenticated">
        <span class="text-uppercase">{{ $store.state.user.emailaddress }} ({{ $store.state.user.organisation }})</span>
        <span>
          <v-menu offset-y class="ml-3">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-account-arrow-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item :to="{name:'Users/Profile'}" dense exact>
                <v-list-item-icon>
                  <v-icon> mdi-account </v-icon>
                </v-list-item-icon>
                <v-list-item-title> My Profile </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="$can('Overview', 'Profile')" :to="{name:'Users'}" dense exact>
                <v-list-item-icon>
                  <v-icon> mdi-format-list-bulleted </v-icon>
                </v-list-item-icon>
                <v-list-item-title> Overview </v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="logout" dense>
                <v-list-item-icon>
                  <v-icon> mdi-logout </v-icon>
                </v-list-item-icon>
                <v-list-item-title> Log Out </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>        
      </div>
    </v-app-bar>

    <v-main>
      <keep-alive include="InProgress">
        <router-view></router-view>
      </keep-alive>
    </v-main>
  </v-app>
</template>

<script>
import NavBar from './components/NavBar.vue'

export default {
  name: 'App',

  components: {
    NavBar,
  },

  data: () => ({
    drawer: true,
    color: "primary"
  }),
  methods: {
    logout() {
      this.$api.releaseAllLocksForUser();
      this.$api.logout();
      this.$store.commit("logout");
      if (this.$msal.isAuthenticated()){
        this.$store.commit('setADSignOut', Date.now());
        this.$msal.signOut();
      }
    },
  },
  created() {
    this.$api.getUISettings()
      .then(resp => {
        this.$store.commit('setUISettings', resp.data);
        document.title = `${ resp.data.title } | ${ resp.data.version }`;
        if (resp.data.color) { this.color = resp.data.color; }
      })
    // document.title = process.env.VUE_APP_TITLE
  },
};
</script>

<style>
  @import './assets/styles.css';
</style>